// @ts-nocheck
import { Text, View, StyleSheet } from '@react-pdf/renderer'
import { Menu } from 'type'

interface Props {
  data: Menu
  color?: string
}

export const PricePhilosohpy: React.FC<Props> = ({ data, color }) => {
  const styles = StyleSheet.create({
    section: {
      margin: '0 10px',
      padding: '10px 30px',
      textAlign: 'center',
      border: `1px solid ${color}}`,
      color
    },
    title: {
      textTransform: 'uppercase',
      fontFamily: 'saa',
      fontSize: '12pt',
      marginBottom: '10px'
    }
  })
  if (!data.pricePhilosophy?.label && !data.pricePhilosophy?.description) {
    return <></>
  }
  return (
    <>
      <View style={styles.section}>
        <Text style={styles.title}>{data.pricePhilosophy?.label}</Text>
        <Text>{data.pricePhilosophy?.description}</Text>
      </View>
    </>
  )
}
